export const SendingFilesErrorModal: string = 'SendingFilesErrorModal';
